// extracted by mini-css-extract-plugin
export default {"bold":"AW2EM0","semi-bold":"BwIQ06","semiBold":"BwIQ06"};